import React from "react";
import { useTranslation } from "react-i18next";
import Button from "../../../../components/Button";

interface AddModalContentProps {
  loading: boolean;
  invoiceError: any;
  onCancel: () => void;
  onSave: (e?: React.FormEvent) => void;
}

const AddModalContent: React.FC<AddModalContentProps> = ({
  loading,
  invoiceError,
  onCancel,
  onSave
}) => {
  const { t } = useTranslation();
  
  return (
    <div className="d-flex gap-3">
      <Button
        className="btn btn-primary"
        text={invoiceError ? t("invoices.addList.pageTexts.modal.createNewBtn") : t("invoices.addList.pageTexts.modal.saveBtn")}
        loading={loading}
        onClick={onSave}
      />
      <Button
        className="btn btn-outline-secondary"
        text={t("invoices.addList.pageTexts.modal.cancelBtn")}
        onClick={onCancel}
      />
    </div>
  );
}

export default AddModalContent;